<template>
	<section class="newsletter">
		<div class="row align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter {
	background: $contentblock-background-color;

	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
	}

	input:not(.button) {
		color: $body-color;
		border: none;
		width: 280px;
		padding: 0 10px;
		line-height: 50px;
		outline: none !important;
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
	}
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

section.newsletter,
.newsletter h2 {
	color: #fff;
}

section.newsletter {
	padding: 50px 0 0;
}

form.newsletter {
	background: #fff;
	padding: 10px;
	display: inline-block;
	margin: 20px auto 50px;
	box-shadow: 0 24px 24px rgb(0 0 0 / 15%);
}

@media (max-width: 680px) {
	.newsletter input {
		width: 100%;
		text-align: center;
	}
}
</style>
